import { IconButton, Stack, Tooltip } from "@mui/material";
import * as React from "react";
import {
    EditModes,
    useTemplateViewEdit,
} from "src/components/providers/template-view-edit-provider";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import styled from "styled-components";

const RemoveButton = styled(IconButton)`
    top: 0;
    right: 0;
    margin-top: -10px;
    margin-right: -10px;
    background-color: #333333;
    &:hover {
        background-color: #333333;
        outline: 2px dashed #474747;
    }
`;
const TemplateRemoveRow = ({
    position,
    templateIndex,
}: {
    position: number;
    templateIndex: number;
}) => {
    const { editView } = useTemplateViewEdit();

    const handleClick = () => {
        if (editView) {
            editView({
                templateIndex,
                rowIndex: position,
                editMode: EditModes.removeRow,
            });
        }
    };

    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
                position: "absolute",
                right: 0,
                zIndex: 102,
                height: "100%",
                marginRight: "-10px",
            }}
            direction="row"
        >
            <Tooltip title="Remove Row">
                <RemoveButton onClick={handleClick} aria-label="add row">
                    <RemoveCircleOutlineIcon />
                </RemoveButton>
            </Tooltip>
        </Stack>
    );
};

export default TemplateRemoveRow;
